import { render, staticRenderFns } from "./add-section-modal.vue?vue&type=template&id=6be5656f&scoped=true"
import script from "./add-section-modal.vue?vue&type=script&lang=js"
export * from "./add-section-modal.vue?vue&type=script&lang=js"
import style0 from "./add-section-modal.vue?vue&type=style&index=0&id=6be5656f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be5656f",
  null
  
)

export default component.exports